import { io } from 'socket.io-client'
import { useState, setState } from '@lib/systems/state'
import { selectCell } from '@game/systems/poms'
import { setContext } from '@game/util/board'

export const UNRANKED = 'unranked'

export const C_FIND_RANKED = 'find_ranked'
export const C_FIND_UNRANKED = 'find_unranked'
export const C_EXECUTE_TURN = 'execute_turn'
export const C_SELECT_CELL = 'select_cell'

export const S_CONNECT = 'connect'
export const S_CONNECT_ERR = 'connect_error'
export const S_DISCONNECT = 'disconnect'
export const S_SESSION_CREATED = 'session_created'
export const S_SESSION_JOINED = 'session_joined'
export const S_PLAYER_DISCONNECT = 'player_disconnect'
export const S_SELECT_CELL = 'select_cell'
export const S_EXECUTE_TURN = 'execute_turn'
export const S_MSG_ERROR = 'msg_error'

class Network {
  state = {
    socket: undefined,
    player: undefined,
    error: undefined,
    connected: false,
    connecting: false,
    waitingForPlayers: false,
    session: undefined
  }

  reset () {
    if (this.state.socket && this.state.socket.offAny) this.socket.offAny()

    this.state.socket = undefined
    this.state.player = undefined
    this.state.error = undefined
    this.state.connected = false
    this.state.connecting = false
    this.state.waitingForPlayers = false
    this.state.session = undefined
  }

  sendMessage (kind, detail) {
    if (!this.state.socket) return

    this.state.socket.emit(kind, {
      detail,
      sessionId: this.state.session.id,
      playerId: this.state.player.id
    })
  }

  findMatch (matchOpts) {
    const state = useState()

    this.reset()

    const socket = io(matchOpts.host)
    this.state.socket = socket

    // Bind socket events

    socket.on(S_CONNECT, () => {
      this.state.connected = true
      this.state.connecting = false

      const matchEvent = matchOpts.kind === UNRANKED
        ? C_FIND_UNRANKED
        : C_FIND_RANKED
      const options = {
        board: 'random'
      }

      socket.emit(matchEvent, options)
    })

    socket.on(S_CONNECT_ERR, (err) => {
      this.state.error = err
      this.state.connected = false
      this.state.connecting = false

      console.error('CONNECTION ERROR', err.message)
    })

    socket.on(S_DISCONNECT, (reason) => {
      this.reset()
    })

    socket.on(S_SESSION_CREATED, ({ session, player }) => {
      this.state.player = player
      this.state.connected = true
      this.state.connecting = false
      this.state.session = session

      console.log('Created a new session.', session)
    })

    socket.on(S_SESSION_JOINED, ({ session, player }) => {
      if (!this.state.player) this.state.player = player
      this.state.connected = true
      this.state.connecting = false
      this.state.session = session
      this.state.waitingForPlayers = false

      setState('board', session.state)

      console.log('Joined session. Game starting.', session)
    })

    socket.on(S_PLAYER_DISCONNECT, () => {
      this.reset()

      // TODO
      // if (is playing a game currently) {
      //   declare you the winner
      // } else {
      //   go back to menu
      // }

      console.log('Other player disconnected.')
    })

    socket.on(S_SELECT_CELL, ({ i, selected }) => {
      setContext(state.board)
      selectCell(i, selected, state.board)
    })

    socket.on(S_EXECUTE_TURN, ({ i, board }) => {
      setContext(state.board)
      // executeTurn(i, state.board)
      state.board = board

      if (board.winner !== false) {
        socket.disconnect()
      }
    })
  }
}
const instance = new Network()

export const networkState = instance.state

export function findMatch (url, matchOpts) {
  instance.findMatch(url, matchOpts)
}

export function sendNetworkMessage (kind, msg, cb) {
  instance.sendMessage(kind, msg, cb)
}
